import ApprovalTransferApplication from './ApprovalTransferApplication'

export default ApprovalTransferApplication